module.exports = __webpack_public_path__ + "NGDC-86f1bbce.webp";